import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-details',
  templateUrl: './operation-details.component.html',
  styleUrls: ['./operation-details.component.scss']
})
export class OperationDetailsComponent {

  constructor(public dialogRef: MatDialogRef<OperationDetailsComponent>,
              @Inject(MAT_DIALOG_DATA) public element: any) {
  }
  close() {
    this.dialogRef.close();
  }
}
